import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MenuAction } from 'src/app/models/menuAction.model';
import { ISelectOption } from 'src/app/models/selectOptions';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { LoggerService } from 'src/app/services/infra/logger/logger.service';

@Component({
  selector: 'app-actions-menu-select',
  templateUrl: './actions-menu-select.component.html',
  styleUrls: ['./actions-menu-select.component.scss'],
})
export class ActionsMenuSelectComponent implements OnChanges {
  @Input() public actions: MenuAction[] = [];
  @Input() public smallSize = false;
  @Input() public forceUsingSelectOptions = false;
  @Output() public actionOnClick = new EventEmitter<MenuAction>();

  public menuActionsOptions: ISelectOption[] = [];

  constructor(
    private readonly _logger: LoggerService,
    private readonly _labelProvider: LabelsProviderPipe
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['actions']) {
      const actions: MenuAction[] = changes['actions'].currentValue;
      this.menuActionsOptions = this.getMenuActionsAsSelectOption(actions);
    }
  }

  public getMenuActionsAsSelectOption(actions: MenuAction[]) {
    return actions
      ? actions.map(
          (action, index) =>
            ({
              id: index.toString(),
              displayName: this._labelProvider.transform(action.displayNameLabel),
              disabled: action.disabled,
              iconPath: action.iconPath,
              tooltip: action.tooltip ?? '',
            }) as ISelectOption
        )
      : [];
  }

  public onSelection(option: ISelectOption) {
    const index = Number(option.id);

    if (Number.isNaN(index)) {
      this._logger.error(`Id of action selected is not a number, id=${option.id}`);
    }

    this.actionOnClick.emit(this.actions[index]);
  }
}
